import { Resource } from '../Resource';
import * as methods from '../methods';
import * as transformers from '../transformers';
const rootPath = 'networks';
const fromRaw = {
    get: ({ adherent_farms_count, id, logo, name, content, device_count, device_locations, distance, network }) => ({
        adherentFarmsCount: adherent_farms_count,
        id,
        name,
        logo,
        deviceCount: device_count,
        deviceLocations: device_locations,
        distanceToTarget: distance,
        description: content?.description,
        type: network,
        ...(content
            ? {
                networkContact: {
                    fullName: content?.nw_contact_name,
                    email: content?.nw_contact_email,
                    telephoneNumber: content?.nw_contact_phone
                },
                weenatContact: {
                    fullName: content?.wee_contact_name,
                    email: content?.wee_contact_email,
                    telephoneNumber: content?.wee_contact_phone
                }
            }
            : undefined)
    })
};
const networks = Resource((requesterBuilder) => {
    return {
        get: methods.get({
            rootPath,
            fromRaw: fromRaw.get,
            requesterBuilder
        }),
        getMany: (query) => requesterBuilder({
            path: rootPath,
            requestCtx: {
                transform: transformers.paginatedResponse(fromRaw.get),
                params: {
                    query: {
                        /** This must be a string */
                        location: `${query?.location[0]},${query?.location[1]}`,
                        max_distance: query?.maxDistance
                    }
                }
            }
        })
    };
});
export default networks;
